module.exports = __webpack_public_path__ + "static/media/mode-501.eb67f3ea.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-501.svg
// module id = 1025
// module chunks = 2